import { render, staticRenderFns } from "./DirectAppeal.vue?vue&type=template&id=709a2197&scoped=true&"
import script from "./DirectAppeal.vue?vue&type=script&lang=js&"
export * from "./DirectAppeal.vue?vue&type=script&lang=js&"
import style0 from "./DirectAppeal.vue?vue&type=style&index=0&id=709a2197&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709a2197",
  null
  
)

export default component.exports